// extracted by mini-css-extract-plugin
export default {"head":"Home_head__HmpwU","loading":"Home_loading__MQHeZ","main_hero":"Home_main_hero__yUDJt","recents":"Home_recents__H9Gxq","transactions_list":"Home_transactions_list__LnH1g"};